import temp from './upload-temp.js'
import en from '../../../language/en-us.json'
import zh from '../../../language/zh-cn.json'

/* eslint-disable no-undef */
class UploadList {
  constructor (ins, options) {
    this.init(options).then(function () {
      UploadList.prototype.events(ins, options)
    }, function (e) {
      console.error('init upload list failed')
      console.error(e)
    })
    this._instance = ins
    this.options = options
  }

  init (options) {
    return new Promise(function (resolve, reject) {
      try {
        let lang
        switch (options.language) {
          case 'zh':
            lang = zh
            break
          case 'en':
            lang = en
            break
          default:
            lang = zh
        }
        if (options.isApprove) {
          lang.isApprove = options.isApprove
        }
        $('body').append(temp(lang))
        // if (options.list_color) {
        //   $('.upload-list-header').css({
        //     'backgroundColor': options.list_color,
        //     'borderColor': options.list_color
        //   })
        //   $('.upload-list-body').css({
        //     'borderColor': options.list_color
        //   })
        //   $('.cancel-all').css({
        //     'color': options.list_color
        //   })

        //   $('#upload-list').addClass(options.list_style)
        // }
        resolve()
      } catch (e) {
        console.log(e)
        reject(e)
      }
    })
  }

  events (ins, options) {
    this.close(ins, options)
    this.minimize()
    this.maximize()
    this.cancel(ins, options)
  }

  /**
   * 显示列表窗口
   */

  show () {
    let isSupportHTML5 = window.localStorage.isSupportHTML5
    let approveExist = window.localStorage.approveExist
    if (isSupportHTML5 === 'false' && approveExist === 'true') {
      $('.upload-list-extend').show()
    } else if (approveExist === 'true') {
      $('.upload-list-extend').show()
    } else {
      $('.upload-list-extend').hide()
    }
    $('#upload-list').fadeIn(800, function () {
      $('#upload-list').animate({
        bottom: '0px'
      })
    })
  }
  /**
   * 获取翻译
   */
  translation () {
    let lang
    switch (window.LenovoData.language) {
      case 'zh':
        lang = zh
        break
      case 'en':
        lang = en
        break
      default:
        lang = zh
    }
    return lang
  }
  listMaskShow () {
    $('#mask-upload').css('display', 'block')
  }
  listMaskHide () {
    $('#mask-upload').css('display', 'none')
  }
  /**
   * 将列表窗口放在最前
   */
  listFirst () {
    $('#upload-list').css({'z-index': 9999999999})
  }
  /**
   * 将列表窗口恢复正常
   */
  listNormal () {
    $('#upload-list').css({'z-index': 9999})
  }
  /**
   * 关闭列表窗口
   */
  close (ins, options) {
    let upl = this
    $('.upload-list .ico-upload-close-normal').click(function () {
      let approveExist = window.localStorage.approveExist
      let isSupportHTML5 = window.localStorage.isSupportHTML5
      if (approveExist === 'true' || approveExist === undefined) {
        options.saveDataWin()
      }
      if (isSupportHTML5 === 'false') {
        if (approveExist === 'true') {
          let checkStatus = ''
          let href = window.location.href
          if (href.indexOf('/approve/list') > -1) {
            checkStatus = window.swfuploadMore.checkUploadStatus()
          } else {
            checkStatus = window.swfuploadCon.checkUploadStatus() && window.swfuploadMore.checkUploadStatus()
          }
          if (checkStatus) {
            upl.closed()
          }
        } else {
          if (window.initUploading.checkUploadStatus()) {
            upl.closed()
          }
        }
      } else if (ins.checkUploadStatus()) {
        upl.closed()
      }
    })
  }

  /**
   * 手动关闭列表窗外报函数
   */
  closed () {
    let upl = this
    $('#upload-list').fadeOut(400, function () {
      $('#upload-list').animate({
        bottom: '-388px'
      })
      upl.clear()
    })
  }

  /**
   * 最小化
   */

  minimize () {
    $('.upload-list .ico-upload-min-normal').click(function () {
      $('#upload-list').fadeIn(400, function () {
        $('#upload-list').animate({
          bottom: '-388px'
        })
      })
    })
  }

  /**
   * 最大化
   */

  maximize () {
    $('.upload-list .ico-upload-max-normal').click(function () {
      $('#upload-list').fadeIn(800, function () {
        $('#upload-list').animate({
          bottom: '0px'
        })
      })
    })
  }

  /**
   * 添加进列表
   * @param file
   */

  add (file) {
    // let color = $('.upload-list-header').css('backgroundColor')
    let lang = this.translation()
    let iconType = this.getUploadType(file)
    let temp = `
    <tr id="${file.id}">
      <td colspan="5" style="position: relative;padding: 0px;">
        <div class="name" title="${file.name}" style="float: left;width: 30%;padding-left: 24px;overflow: hidden;white-space: nowrap;text-align:left;text-overflow: ellipsis;">
          <div style:"line-height:40px;" class="${iconType} icon-span icon-file"></div><div style:"line-height:40px;">${file.name}</div>
        </div>
        <div class="percentage" style="float: left;width: 25%;padding: 0 10px;text-align: left;height:40px;";>
          <span style="display: none">${file.progress === '100%' ? file.progress : lang.in_the_queue}</span>
          <span style="display: none">${file.clientProgress === '--' ? '--' : ''}</span>
        </div>
        <div class="size" style="float: left;width: 10%;padding: 0 10px;text-align: left">
          ${parseSize(file.size)}
        </div>
        <div class="time" style="float: left;width: 12%;padding: 0 10px;text-align: left">
          ${file.time}
        </div>
        <div class="infos" style="float: left;width: 8%;padding-left:4px;text-align: left;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;color:#FB5B77">
          <span class="error" style="line-height: 20px;"></span>
          <span class="pause" data-id="${file.id}" data-statues="${file.progress === '100%' ? 'hide' : 'show'}" style="${file.progress === '100%' ? 'display: none' : ''}">
            <i class="icon-upload ico-upload-cancel" ></i>
          </span>
          <span class="check" style="${file.progress === '100%' ? '' : 'display: none'}">
            <i class="icon-upload ico-upload-finish" style="${file.clientProgress === '--' ? 'display: none' : ''}"></i>
            ${file.clientProgress === '--' ? '--' : ''}
          </span>
        </div>
        <div style="width:170px;height:10px;position: absolute;left: 242px;top: 14px;border:1px solid #e8e8e8;border-radius:10px;">
        <div class="progressbar" style="width: ${file.percentage}%;height: 10px;background-color: rgba(123, 223, 146, 1);border-radius:10px;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=#7bdf92,endColorstr=#7bdf92);"></div>
        </div>
      </td>
    </tr>
    `
    $('#body-list').append(temp)
  }

  // <td class="name" title="${file.name}" style="position: absolute;width: 100%">
  //   ${file.name}
  //   <div style="width: 0%;height: 40px;background-color: rgba(22, 122, 248, 0.2);position: absolute;left: 0;top: 0;"></div>
  // </td>
  // <td class="percentage" style="position: relative">
  //   <div>
  //     <!--<span style="position: absolute;left: 10px;right: 10px;color: #606266;text-align: center;">${file.percentage} %</span>-->
  //     <span style="color: #606266;text-align: center;">队列中</span>
  //   </div>
  // </td>
  // <!--<td class="error" style="line-height: 20px;color: #d71919;"></td>-->
  // <td class="size">${parseSize(file.size)}</td>
  // <td class="time">${file.time}</td>
  // <td class="error">
  //   <span class="error" style="line-height: 20px;color: #d71919;"></span>
  //   <span class="pause" data-id="${file.id}">
  //     <i class="fa fa-ban"></i>
  //   </span>
  //   <span class="check" style="display: none">
  //     <i class="fa ico-upload-finish"></i>
  //   </span>
  // </td>

  /**
   * 判断上传类型
   * @param file
   * 采取循环对象方式ie下有bug 重新采取switch方式更改类型图片
   */
  // 用于pc端审批上传 判断是不是文件夹类型
  getUploadType (typeIcon) {
    if (typeIcon.isFolder) {
      return 'folder'
    }
    var ImgType = typeIcon
    console.log(ImgType)
    console.log(typeIcon)
    if (ImgType) {
      ImgType = ImgType.name.split('.').pop().toLowerCase()
    }
    var jar = {
      'folder_team': 'folder_team',
      'folder_share': 'folder_share',
      'cloud_share': 'cloud_share',
      'folder_cloud': 'folder_cloud',
      'folder': 'folder',
      'doc': 'word',
      'docx': 'word',
      'wps': 'word',
      'rtf': 'word',
      'txt': 'text',
      'jpg': 'pic',
      'JPG': 'pic',
      'jpeg': 'pic',
      'JPEG': 'pic',
      'png': 'pic',
      'BMP': 'pic',
      'bmp': 'pic',
      'gif': 'pic',
      'GIF': 'pic',
      'tiff': 'pic',
      'pcx': 'pic',
      // 'psd': 'pic',
      'thm': 'pic',
      'yuv': 'pic',
      'pps': 'ppt',
      'dps': 'ppt',
      'ppsx': 'ppt',
      'ppt': 'ppt',
      'pptx': 'ppt',
      'xls': 'excel',
      'xlsx': 'excel',
      'et': 'excel',
      'csv': 'excel',
      'lock': 'locks',
      'pct': 'pdf',
      'pdf': 'pdf',
      'pmd': 'pdf',
      'mp3': 'music',
      'aac': 'music',
      'flac': 'music',
      'ape': 'music',
      'wma': 'music',
      'ra': 'music',
      'wav': 'music',
      'mid': 'music',
      'vqf': 'music',
      'aif': 'music',
      'au': 'music',
      'dsp': 'music',
      'cmf': 'music',
      'cda': 'music',
      'mod': 'music',
      'iff': 'music',
      'm3u': 'music',
      'm4a': 'music',
      'mpa': 'music',
      'aiff': 'music',
      'ac3': 'music',
      'mur': 'music',
      'mp2': 'music',
      'amr': 'music',
      'avi': 'video',
      'mov': 'video',
      'mpg': 'video',
      'mp4': 'video',
      'xv': 'video',
      '3gp': 'video',
      'divx': 'video',
      'rm': 'video',
      'rmvb': 'video',
      'asf': 'video',
      'wmv': 'video',
      'vob': 'video',
      'mkv': 'video',
      // 'dat': 'video',
      '264': 'video',
      'flv': 'video',
      '3g2': 'video',
      'asx': 'video',
      'f4v': 'video',
      'h.264': 'video',
      'ts': 'video',
      'mts': 'video',
      'm4v': 'video',
      'exe': 'exe',
      'rar': 'zip',
      'zip': 'zip',
      'zipx': 'zip',
      '7z': 'zip',
      'cab': 'zip',
      'arj': 'zip',
      'jar': 'zip',
      'lzh': 'zip',
      'bin': 'zip',
      'deb': 'zip',
      'gz': 'zip',
      'rpm': 'zip',
      'sit': 'zip',
      'sitx': 'zip',
      'tar': 'zip',
      'cad': 'cad',
      'dxf': 'cad',
      'psd': 'ps',
      'ai': 'ai',
      'dw': 'dw',
      'fil': 'fl',
      'id': 'id',
      'ae': 'ae',
      '3d': '3d',
      'eps': 'svg',
      'svg': 'svg',
      'cdr': 'svg',
      'pages': 'other',
      'log': 'other',
      'diff': 'other',
      'msg': 'other',
      'xps': 'other',
      'chm': 'other',
      'pdg': 'other',
      'key': 'other',
      'efx': 'other',
      'sdf': 'other',
      'vcf': 'other',
      'wks': 'other',
      'munbers': 'other',
      '3dm': 'other',
      'max': 'other',
      'com': 'other',
      'bat': 'other',
      'scr': 'other',
      'lib': 'other',
      'app': 'other',
      'cgi': 'other',
      'gadget': 'other',
      'vb': 'other',
      'wsf': 'other',
      'accdb': 'other',
      'db': 'other',
      'dbf': 'other',
      'mdb': 'other',
      'pdb': 'other',
      'sql': 'other',
      'cpl': 'setting',
      'cur': 'setting',
      'dll': 'setting',
      'dmp': 'setting',
      'drv': 'setting',
      'lnk': 'setting',
      'sys': 'setting',
      'cfg': 'setting',
      'ini': 'setting',
      'keychain': 'setting',
      'prf': 'setting',
      'c': 'cpp',
      'class': 'cpp',
      'cpp': 'cpp',
      'cs': 'cpp',
      'dtd': 'cpp',
      'fla': 'cpp',
      'java': 'cpp',
      'm': 'cpp',
      'pl': 'cpp',
      'py': 'cpp',
      'html': 'html',
      'htm': 'html',
      'xhtml': 'html',
      'php': 'html',
      'css': 'html',
      'js': 'html',
      'xml': 'html',
      'asp': 'html',
      'cer': 'html',
      'rss': 'html',
      'ttf': 'font',
      'fnt': 'font',
      'otf': 'font',
      'fon': 'font',
      'dmg': 'iso',
      'toast': 'iso',
      'vcd': 'iso',
      'iso': 'iso',
      'dwg': 'dwg',
      'dpt': 'ppt',
      'wpt': 'word',
      'ett': 'excel'
    }
    var Extension
    $.map(jar, function (key, value) {
      if (ImgType === value) {
        Extension = key
      }
    })

    if (Extension === undefined) {
      Extension = 'other'
    }
    typeIcon = Extension
    return typeIcon
  }

  // getUploadType (file) {
  //   let type
  //   var fileType = file.name.split('.').pop().toLowerCase()
  //   switch (fileType) {
  //     case 'txt':
  //       type = 'icon-txt'
  //       break
  //     case 'epub':
  //       type = 'icon-txt'
  //       break
  //     case 'chm':
  //       type = 'icon-txt'
  //       break
  //     case 'png':
  //       type = 'icon-png'
  //       break
  //     case 'bmp':
  //       type = 'icon-png'
  //       break
  //     case 'jpg':
  //       type = 'icon-png'
  //       break
  //     case 'jpeg':
  //       type = 'icon-png'
  //       break
  //     case 'gif':
  //       type = 'icon-png'
  //       break
  //     case 'doc':
  //       type = 'icon-word'
  //       break
  //     case 'dot':
  //       type = 'icon-word'
  //       break
  //     case 'dotx':
  //       type = 'icon-word'
  //       break
  //     case 'docm':
  //       type = 'icon-word'
  //       break
  //     case 'dotm':
  //       type = 'icon-word'
  //       break
  //     case 'wps':
  //       type = 'icon-world'
  //       break
  //     case 'dwg':
  //       type = 'icon-cad'
  //       break
  //     case 'dwt':
  //       type = 'icon-cad'
  //       break
  //     case 'dxf':
  //       type = 'icon-cad'
  //       break
  //     case 'max':
  //       type = 'icon-max'
  //       break
  //     case 'pptx':
  //       type = 'icon-ppt'
  //       break
  //     case 'ppt':
  //       type = 'icon-ppt'
  //       break
  //     case 'pps':
  //       type = 'icon-ppt'
  //       break
  //     case 'ppsx':
  //       type = 'icon-ppt'
  //       break
  //     case 'ppa':
  //       type = 'icon-ppt'
  //       break
  //     case 'ppam':
  //       type = 'icon-ppt'
  //       break
  //     case 'pot':
  //       type = 'icon-ppt'
  //       break
  //     case 'potx':
  //       type = 'icon-ppt'
  //       break
  //     case 'xlsx':
  //       type = 'icon-excel'
  //       break
  //     case 'xlsm':
  //       type = 'icon-excel'
  //       break
  //     case 'xltx':
  //       type = 'icon-excel'
  //       break
  //     case 'xltm':
  //       type = 'icon-excel'
  //       break
  //     case 'xlsb':
  //       type = 'icon-excel'
  //       break
  //     case 'xlam':
  //       type = 'icon-excel'
  //       break
  //     case 'mav':
  //       type = 'icon-music'
  //       break
  //     case 'aiff':
  //       type = 'icon-music'
  //       break
  //     case 'au':
  //       type = 'icon-music'
  //       break
  //     case 'mp1':
  //       type = 'icon-music'
  //       break
  //     case 'pm2':
  //       type = 'icon-music'
  //       break
  //     case 'mp3':
  //       type = 'icon-music'
  //       break
  //     case 'ra':
  //       type = 'icon-music'
  //       break
  //     case 'rm':
  //       type = 'icon-music'
  //       break
  //     case 'ram':
  //       type = 'icon-music'
  //       break
  //     case 'mid':
  //       type = 'icon-music'
  //       break
  //     case 'wmv':
  //       type = 'icon-video'
  //       break
  //     case 'asf':
  //       type = 'icon-video'
  //       break
  //     case 'asx':
  //       type = 'icon-video'
  //       break
  //     case 'mp4':
  //       type = 'icon-video'
  //       break
  //     case 'rmvb':
  //       type = 'icon-video'
  //       break
  //     case '3gp':
  //       type = 'icon-video'
  //       break
  //     case 'mov':
  //       type = 'icon-video'
  //       break
  //     case 'm4v':
  //       type = 'icon-video'
  //       break
  //     case 'avi':
  //       type = 'icon-video'
  //       break
  //     case 'mkv':
  //       type = 'icon-video'
  //       break
  //     case 'flv':
  //       type = 'icon-video'
  //       break
  //     case 'vob':
  //       type = 'icon-video'
  //       break
  //     case 'pdf':
  //       type = 'icon-pdf'
  //       break
  //     case 'psd':
  //       type = 'icon-psd'
  //       break
  //     case 'rar':
  //       type = 'icon-zip'
  //       break
  //     case 'zip':
  //       type = 'icon-zip'
  //       break
  //     case '7z':
  //       type = 'icon-zip'
  //       break
  //     case 'gz':
  //       type = 'icon-zip'
  //       break
  //     case 'bz':
  //       type = 'icon-zip'
  //       break
  //     case 'ace':
  //       type = 'icon-zip'
  //       break
  //     case 'uha':
  //       type = 'icon-zip'
  //       break
  //     case 'apk':
  //       type = 'icon-apk'
  //       break
  //     case 'exe':
  //       type = 'icon-exe'
  //       break
  //     case 'xmap':
  //       type = 'icon-mind'
  //       break
  //     case 'html':
  //       type = 'icon-html'
  //       break
  //     case 'xml':
  //       type = 'icon-html'
  //       break
  //     default:
  //       type = 'icon-normal'
  //   }
  //   return type
  // }

  /**
   * 清空列表
   */

  clear () {
    $('#body-list').children('tr').remove()
    let isSupportHTML5 = window.localStorage.isSupportHTML5
    if (isSupportHTML5 === 'false') {
      $('.upload-list-extend').hide()
    } else {
      $('.upload-list-extend').html('')
    }
    window.uploadCounts = 0
  }

  /**
   * 响应上传进度
   * @param file
   */

  progress (file) {
    $('#' + file.id + ' .percentage span').last().text(parsePercentage(file.percentage) + '%') // 百分比
    $('#' + file.id + ' .progressbar').last().css('width', file.percentage + '%') // 进度条
    $('#' + file.id + ' .time').last().text(file.time) // 剩余时间
    // let color = $('#' + file.id + ' .percentage div span').css('color')
    // if (file.percentage >= 45 && color !== 'rgb(255, 255, 255)') {
    //   $('#' + file.id + ' .percentage div span').css({
    //     'color': '#ffffff'
    //   })
    // }
  }

  /**
   * 文件上传成功
   * @param file
   * @param fileList
   */

  success (file, fileList) {
    $('#' + file.id + ' span.pause').hide()
    $('#' + file.id + ' span.pause').attr('data-statues', 'hide')
    $('#' + file.id + ' span.check').show()
    $('#' + file.id + ' span.check').attr('data-checkStatues', 'success')
    $('#' + file.id + ' span.error').html('')
    $('#' + file.id + ' .percentage span').text('100%')
    $('#' + file.id + ' .progressbar').css('width', '100%')
    // $('#' + file.id + ' .percentage div span').css({'color': '#ffffff'})
    $('#' + file.id + ' .time').text('00:00:00') // 剩余时间
    for (let f of fileList) {
      if (f.filestatus !== -4) return
    }
    if (localStorage.approveExist !== 'true') { // 审批页面list列表不消失
      $('#upload-list').fadeIn(400, function () {
        $('#upload-list').animate({
          bottom: '-388px'
        })
      })
    }
  }

  /**
   * 暂停文件上传
   * @description 列表按钮绑定点击事件，通过传入Vue或SWF实例调用对应的取消上传方法
   * @param ins Vue 或 SWF实例
   * SWF cancelUpload ( file_id, trigger_error_event )
   * 取消文件的上传
   * 参数file_id为要取消的文件的id,如果该参数为undefined或者未填写，则会取消队列里的第一个文件
   * 参数trigger_error_event接受一个布尔值，当为false时取消文件不会触发uploadError事件，默认为true
   */

  cancel (ins, options) {
    let lang = this.translation()
    $('#upload-list').delegate('.pause', 'click', function () {
      let fid = $(this).attr('data-id')
      ins.cancelUpload(fid, false) // cancelUpload为SWF原生方法 统一为不触发error
      let file = ins.getFile(fid) // SWF 和 Vue 实例中获取文件方法
      options.handleCancel(file) // 触发handleCancel
      $('#' + fid + ' span.pause').hide()
      $('#' + file.id + ' span.pause').attr('data-statues', 'hide')
      $('#' + fid + ' div.infos').append(`<i style="color: #fb5b77" class="icon-upload ico-upload-stop"></i>`)
      $('#' + fid + ' .percentage span').text(lang.canceled)
    })
    if (document.cookie.indexOf('Client-Agent') === -1) {
      // GY,6.0BUG,容错处理防止window.getCookie报错
      $('#upload-list .cancel-all').click(function () {
        $('.upload-list .infos').each(function (index, element) {
          let $dom = $(this)
          if ($dom.find('.pause') && $dom.find('.pause').data('statues') === 'show') {
            let fid = $(this).attr('data-id')
            ins.cancelUpload(fid, false)
            $dom.find('span.pause').attr('data-statues', 'hide').hide()
            $dom.html(`<i style="color: #fb5b77" class="icon-upload ico-upload-stop"></i>`)
          }
          $('#upload-list').css({'z-index': 9999})
        })
        $('#upload-list .ico-upload-min-normal').trigger('click')
      })
    }
  }
  /**
   * 错误消息显示
   * @description Upload.prototype.error(message, file)
   * 传入要显示的错误消息和当前文件
   * @param message
   * @param file
   */

  error (message, file) {
    message = message || '上传失败'
    if (file) {
      if (window.localStorage.isSupportHTML5 === 'false') {
        $('#' + file.id + ' span.pause').hide()
        $('#' + file.id + ' span.pause').attr('data-statues', 'hide')
        $('#' + file.id + ' span.check').hide()
        $('#' + file.id + ' span.error').html('')
        $('#' + file.id + ' span.error').append('<i style="color: #fb5b77" class="icon-upload ico-upload-fail"></i>' + message)
        $('#' + file.id + ' span.error').attr('title', message)
        $('#' + file.id + ' .percentage span').text('0%')
        $('#' + file.id + ' .progressbar').css('width', '0%')
        // $('#' + file.id + ' .percentage span').css({'color': '#606266'})
        $('#' + file.id + ' .time').text('00:00:00')
      } else {
        $('#' + file.id + ' span.pause').hide()
        $('#' + file.id + ' span.pause').attr('data-statues', 'hide')
        $('#' + file.id + ' span.check').hide()
        $('#' + file.id + ' span.error').html('')
        $('#' + file.id + ' span.error').append('<i style="color: #fb5b77" class="icon-upload ico-upload-fail"></i>' + message)
        $('#' + file.id + ' span.error').attr('title', message)
        $('#' + file.id + ' .percentage span').text('0%')
        $('#' + file.id + ' .progressbar').css('width', '0%')
        // $('#' + file.id + ' .percentage span').css({'color': '#606266'})
        $('#' + file.id + ' .time').text('00:00:00')
      }
    }
  }

  // warn (message) {
  //   if ($('#warnInfo').length > 0) {
  //     $('#warnInfo').remove()
  //   }
  //   let warn = `
  //   <div id="warnInfo" style="width:  100%;height: 40px;background-color: #e6a23c;text-align: center;line-height: 40px;color:  #ffffff;">
  //     ${message}
  //   </div>
  //   `
  //   $('.upload-list-body table').before(warn)
  // }
  //
  // clearWarn () {
  //   $('#warnInfo').remove()
  // }

  warn (type, ...params) {
    if ($('#warnInfo').length > 0) {
      $('#warnInfo').remove()
    }
    let lang
    switch (Upload.defaults.language) {
      case 'zh':
        lang = zh
        break
      case 'en':
        lang = en
        break
      default:
        lang = zh
    }
    let warnMessage = lang[type]

    for (let i = 0; i < params.length; i++) {
      warnMessage = warnMessage.replace('{' + i + '}', params[i])
    }
    let warn = `
    <div id="warnInfo" style="width:  100%;height: 40px;background-color: #e6a23c;text-align: center;line-height: 40px;color:  #ffffff;">
      ${warnMessage}
    </div>
    `
    $('.upload-list-body table').before(warn)
  }

  clearWarn () {
    $('#warnInfo').remove()
  }
}

/**
 * 解析文件进度
 * @param val
 * @returns {number}
 */

function parsePercentage (val) {
  return parseInt(val, 10)
}

/**
 * 解析文件大小
 * @param val
 * @returns {string}
 */

function parseSize (val) {
  let size = ''
  if (val < 0.1 * 1024) {
    size = val.toFixed(2) + 'B'
  } else if (val < 0.1 * 1024 * 1024) {
    size = (val / 1024).toFixed(2) + 'KB'
  } else if (val < 0.1 * 1024 * 1024 * 1024) {
    size = (val / (1024 * 1024)).toFixed(2) + 'MB'
  } else {
    size = (val / (1024 * 1024 * 1024)).toFixed(2) + 'GB'
  }
  let sizestr = size + ''
  let len = sizestr.indexOf('.')
  let dec = sizestr.substr(len + 1, 2)
  if (dec === '00') {
    return sizestr.substring(0, len) + sizestr.substr(len + 3, 2)
  }
  return sizestr
}

export default UploadList



// WEBPACK FOOTER //
// ./src/components/upload/upload_list/upload-list.js